import { render, staticRenderFns } from "./GreenPremiseForm.vue?vue&type=template&id=7027161e&scoped=true&"
import script from "./GreenPremiseForm.vue?vue&type=script&lang=js&"
export * from "./GreenPremiseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7027161e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7027161e')) {
      api.createRecord('7027161e', component.options)
    } else {
      api.reload('7027161e', component.options)
    }
    module.hot.accept("./GreenPremiseForm.vue?vue&type=template&id=7027161e&scoped=true&", function () {
      api.rerender('7027161e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/GreenPremiseForm.vue"
export default component.exports